// import { useDisclosure } from "@mantine/hooks";
import {
  Button,
  Box,
  createStyles,
  Text,
  Select,
  ActionIcon,
  TextInput,
  Group,
  Badge,
  Modal,
  Table,
  Drawer,
  ScrollArea,
  Paper,
  Divider,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { IconChevronDown } from "@tabler/icons-react";
import { useSelector } from "react-redux";
import {
  addPatient,
  getAllPatients,
  getAllPatientsModal,
} from "../../services/patient";
import BillingSearchBar from "../Document/BillingSearchBar";
import { useForm } from "@mantine/form";
import { showError } from "../../utils";
import swal from "sweetalert";
import { getBillingProvider } from "../../services/billingprovider";
import { getpayer } from "../../services/payer";
import { getdiagnosiscode } from "../../services/servicecode";
import { getelibilitystatus } from "../../services";
import { stateZipCodes } from "../../utils/zipCodes";
import CheckEligibilty from "./CheckEligibilty";
import { DatePickerInput } from "@mantine/dates";
import { IconSearch } from "@tabler/icons-react";
import ProviderServicesLookupModal from "./providerServicesLookupModal";


const useStyles = createStyles(() => ({
  mainbox: {
    background: " #F5F5F5",
    padding: "13px 19px",
  },

  addbox: {
    // padding: "12px 12px 20px 30px",
    padding: "20px 15px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  newinputbox: {
    background: "#FFF !important",
    border: "1px solid #E5E5E5 !important",
    borderRadius: "8px !important",
    width: "79px !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    color: "#000 !important",
    textAlign: "center !important",
    justifyContent: "center !important",
    alignSelf: "center !important",
    alignItems: "center !important",

    ".mantine-1vlckrq": {
      textAlign: "center",
      fontFamily: "Inter !important",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      color: "#000 !important",
    },
    ".mantine-6kqrk6": {
      textAlign: "center",
    },
  },

  lookupflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  formRow: {
    width: "100%",
    display: "flex",
    // justifyContent: "space-between",
    gap: "18px",
    marginBottom: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },
  },

  addbtn: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "20px",
    marginTop: "10%",
  },

  minitags: {
    borderRadius: "16px",
    background: "#F2F4F7",
    padding: "4px 10px 4px 12px",
    width: "max-content",
    display: "flex",
    gap: "4px",
    flexDirection: "row",
    // height:'28px'
  },

  maintags: {
    marginTop: "19px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "20px",
  },

  container: {
    display: "flex",
    flexDirection: "column",
    // gap: "6px",
    width: "100%",
  },
  boxWrapper: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    padding: "5px 15px",
    backgroundColor: "#fff",
    width: "100%",
  },
  selectBilling: {
    width: "65px",
    minWidth: "65px",
    fontSize: "14px",
  },

  tableheader: {
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#000 !important",
  },

  inputField: {
    flex: 1,
    fontSize: "14px",
    border: "none",
    padding: "0",
  },

  table: {
    // borderRadius: "8px",
    // border: "1px solid #E5E5E5",
    background: "#FFF",
    padding: "12px 0px",
  },

  datepickerinput: {
    width: "100%",
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid  #D0D5DD",
    // height:'49px',
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",

    backgroundColor: bgColor,
  },

  selectnumber: {
    width: "70px",
    padding: "5px 5px",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  fullw: {
    width: "100% !important",
  },

  selecttext: {
    width: "120px",
    padding: "5px 15px",

    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  widthbox: {
    width: "100%",
  },

  stepsclient: {
    borderRadius: "8px",
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 16px 0px 16px",
    marginTop: "28px",
    marginBottom: "28px",

    "@media (max-width:1370px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },

  date: {
    width: "100%",
    backgroundColor: bgColor,
    margin: "auto",
  },

  dateBgChange: {
    borderRadius: "5px",
    padding: "5px 15px",
    "& input": {
      backgroundColor: "transparent",
      fontSize: "0.875rem",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    // width:'300px'
    // width: "min-content"
    // justifyContent:'flex-end'
  },

  gap: {
    display: "flex",
    gap: "8px",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "19px",

    "@media (max-width:1370px)": {
      flexDirection: "column",
      gap: "10px",
    },
  },

  dbtnflex: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
    // justifyContent: "space-between",
    justifyContent: "flex-end",
    gap: "20px",
    // justifyContent: "flex-end",

    "@media (max-width:950px)": {
      flexDirection: "column",
      marginBottom: "20px",
      marginTop: "20px",
      gap: "10px",
    },
  },

  dflex: {
    display: "flex",
    // justifyContent: "space-between",
    flexDirection: "row",
    // justifyContent: "space-between",
    // gap: "20px",
    gap: "16px",
    // justifyContent: "flex-end",

    "@media (max-width:950px)": {
      flexDirection: "column",
      marginBottom: "20px",
      marginTop: "20px",
      gap: "10px",
    },
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  searchbox: {
    // marginTop: "20px",
    marginBottom: "24px",
  },

  backNextBtn: {
    marginTop: "30px",
    marginBottom: "30px",
    "@media (max-width:950px)": {
      marginBottom: "10px",
      marginTop: "10px",
    },
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },

  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#FFFFFF",
      opacity: 0.8,
    },
  },
}));
// const bgColor = "#D9D9D9";

const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  // const useStyles = createStyles((theme) => ({
  //   textInputBox: {
  //     width: "100%",
  //     padding: "5px 15px",
  //     borderRadius: "5px",
  //     backgroundColor: bgColor,
  //     "& input": {
  //       backgroundColor: "transparent",
  //       border: "none",
  //       paddingInline: 0,
  //     },
  //   },
  // }));
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "10px 14px",
      borderRadius: "8px",
      height: "44px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  // const useStyles = createStyles((theme) => ({
  //   textInputBox: {
  //     width: "100%",
  //     padding: "5px 11px",
  //     borderRadius: "5px",
  //     backgroundColor: bgColor,
  //     "& input": {
  //       border: "none",
  //       paddingInline: 0,
  //       backgroundColor: "transparent",
  //     },
  //   },
  // }));

  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={25} />}
        rightSectionWidth={30}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function AddClient({ state, setState, payerclient }) {
  const { classes } = useStyles();
  const [currentStep, setCurrentStep] = useState(0);
  // const [provider, setProvider] = useState(selectedProvider || null);

  const [selectedProvider, setSelectedProvider] = useState(null);

  const [facility, setFacility] = useState([]);
  const [payer, setPayer] = useState(null);
  const [services, setServices] = useState(null);
  const [servicesinfo, setServicesinfo] = useState([]);
  const { allpayer } = useSelector((state) => state.payer);

  useEffect(() => {
    getpayer();
  }, []);

  const [openlookup, setOpenLookup] = useState(false);
  const eligibilitystatus = useSelector(
    (state) => state?.billing?.eligibilitystatus
  );
  const [isEligibilityModalVisible, setIsEligibilityModalVisible] =
    useState(false);

  // console.log("openlookup", openlookup);
  // console.log('selectedProvider.services',selectedProvider);

  // useEffect(() => {
  //   selectedProvider &&
  //     selectedProvider?.facilityId &&
  //     setFacility([...facility, selectedProvider?.facilityId]);
  // }, [selectedProvider]);

  // console.log(selectedProvider, "########");
  // console.log("allpayer", allpayer);
  // console.log("payer", payer);

  const addService = () => {
    if (
      !services ||
      !services.servicechargeAmount ||
      !services.servicechargeNumber ||
      !services.servicechargetype ||
      !services.servicenumber ||
      !services.servicetitle ||
      !services.totalCharge
    ) {
      showError("Missing or empty fields", 400);
      return;
    }
    if (services) {
      setServicesinfo((prevServicesinfo) => [...prevServicesinfo, services]);
      setServices(null);
    }
  };

  // console.log("services", services);

  const [diagnosis, setDiagnosis] = useState([]);
  const [diagnosisField, setDiagnosisField] = useState({
    code: "",
    name: "",
  });
  const [diagnosisSearchValue, setDiagnosisSearchValue] = useState("");

  const handleChangeDiagnosis = () => {
    if (!diagnosisField.code || !diagnosisField.name) {
      showError("Missing or empty fields", 400);
      return;
    }

    const newDiagnosis = {
      code: diagnosisField.code,
      name: diagnosisField.name,
    };

    setDiagnosis((prevDiagnosis) => [...prevDiagnosis, newDiagnosis]);

    // Clear the diagnosisField after adding
    setDiagnosisField({
      code: "",
      name: "",
    });
  };

  const removeDiagnosis = (index) => {
    let temp = diagnosis?.filter((_, i) => i !== index);
    setDiagnosis(temp);
  };

  const removeServices = async (index) => {
    const willDelete = await swal({
      title: `Are you sure want to delete this service?`,
      text: "",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) {
      let temp = servicesinfo?.filter((_, i) => i !== index);
      setServicesinfo(temp);
    }
  };

  // console.log("diagnosis", diagnosis);

  const handleServiceChange = (value) => {
    setServices(value);
  };

  const handleServiceFieldChange = (field, value) => {
    setServices((prevServices) => {
      const updatedServices = {
        ...prevServices,
        [field]: value,
      };

      if (
        updatedServices.servicechargeNumber &&
        updatedServices.servicechargeAmount
      ) {
        updatedServices.totalCharge =
          updatedServices.servicechargeNumber *
          updatedServices.servicechargeAmount;
      }

      return updatedServices;
    });
  };

  const allfacilty = useSelector((state) => state.facility);

  const alldiagnosiscode = useSelector(
    (state) => state.servicecode.alldiagnosisCode
  );


    const form = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      middleName: "",
      gender: "",
      // dob: "",
      dob: new Date(),
      previousAddress: "",
      previousAddress2: "",
      socialSecurityNumber: "",
      lastFourDigits: "",
      dietaryRestrictions: "",
      contagious: "no",
      patientWounds: "no",
      isKnownIllness: "no",
      zipCode: "",
      state: "",
      city: "",
      phone: "",
      admissionDate: new Date(),
      insurancefirstName: "",
      insurancemiddleName:"",
      insurancelastName: "",
      insuranceaddress1: "",
      insuranceaddress2: "",
      insurancecity: "",
      insurancestate: "",
      insurancezipCode: "",
      insuranceidentificationNumber: "",
      insurancegroupPolicyNumber: "",
      insurancedob: new Date(),
      insurancegender: "",
      insurancerelationshipToInsured: "",
      insuranceauthorization: "",
      insuranceauthorizationEndDate: new Date(),
      insurancepayer: {},


    },
    // validate: {
    //   firstName: (value) => (value ? null : "Required"),
    //   dob: (value) => (value ? null : "Required"),
    //   previousAddress: (value) => (value ? null : "Required"),
    //   // facility: (value) => (value ? null : "Required")
    //   //   knownAllergies: (value) => (value ? null : "Required")
    //   //   dietaryRestrictions: (value) => (value ? null : "Required")
    // },
  });
  // console.log("alldiagnosiscode", alldiagnosiscode);

  const allbillingprovider = useSelector(
    (state) => state.billingprovider?.allbillingprovider
  );

  // State to hold the values of each form field
  const [insuranceData, setInsuranceData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    identificationNumber: "",
    groupPolicyNumber: "",
    dob: new Date(),
    gender: "",
    relationshipToInsured: "",
    authorization: "",
    authorizationEndDate: new Date(),
    payer: {},
  });



  // console.log("insuranceData", insuranceData);
  // console.log("payerclient", payerclient);

  const [insuranceArray, setInsuranceArray] = useState([]);

  // Handle input change

  // const handleInsuranceChange = (id, value) => {
  //   setInsuranceData((prevData) => ({
  //     ...prevData,
  //     [id]: value,
  //   }));
  // };

  const handleInsuranceChange = (id, value) => {
    setInsuranceData((prevData) => {
      const updatedData = {
        ...prevData,
        [id]: value,
      };

      if (insuranceArray.length > 0) {
        setInsuranceArray([updatedData]);
        console.log("Insurance data updated:", updatedData);
      } else {
        setInsuranceArray([updatedData]);
        console.log("New insurance data added:", updatedData);
      }

      return updatedData;
    });
  };


 
 


  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      addClient: false,
    }));
    setCurrentStep(0);
  };

  useEffect(() => {
    getBillingProvider();
  }, []);

  const DEBOUNCE_DELAY = 500;

  const fetchEligibilityStatus = async (payload) => {
    try {
      await getelibilitystatus(payload);
    } catch (error) {
      console.error("Error fetching eligibility status:", error);
    }
  };

  useEffect(() => {
    if (
      form.values.lastName === "" ||
      form.values.firstName === "" ||
      !payerclient[0]?.id ||
      !selectedProvider
    )
      return;

    const payload = {
      ins_name_l: form.values.lastName || "",
      ins_name_f: form.values.firstName || "",
      payerid: payerclient[0]?.id || "",
      pat_rel: insuranceData?.relationshipToInsured || "18",
      fdos: "2022-10-13",
      prov_npi: selectedProvider?.billingIdentifier?.number,
      prov_taxid: selectedProvider?.taxonomy,
    };

    const debouncedFetchEligibilityStatus = debounce((payload) => {
      fetchEligibilityStatus(payload);
    }, DEBOUNCE_DELAY);

    debouncedFetchEligibilityStatus(payload);

    return () => {
      debouncedFetchEligibilityStatus.cancel();
    };
  }, [
    form.values.firstName,
    form.values.lastName,
    payerclient,
    selectedProvider,
    insuranceData?.relationshipToInsured,
  ]);

  const onSave = async (valuesObj) => {
    try {
      const values = form.values;

console.log('values',values);


      let missingFields = [];
      Object.entries(values)
        .filter(
          ([key, _]) =>
            key !== "previousAddress2" &&
            key !=="insuranceaddress2"&&
            key !== "socialSecurityNumber" &&
            key !== "lastFourDigits" &&
            key !== "dietaryRestrictions" &&
            key !== "middleName"&&
            key !=="insurancegroupPolicyNumber"&&
            key !=="insurancemiddleName"
        )
        // .forEach(([key, value]) => !value && missingFields.push(key));
          .forEach(([key, value]) => {
    if (
      !value ||
      (key === "insurancePayer" &&
        typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0)
    ) {
      missingFields.push(key);
    }
  });
      if (facility?.length < 1) missingFields.push("Facility");
      if (!selectedProvider) missingFields.push("provider");
      if (servicesinfo.length < 1) missingFields.push("Service");
      if (diagnosis.length < 1) missingFields.push("Dygnosis");
     // if (insuranceArray.length < 1) missingFields.push("insurance missing");

      // if (insuranceArray.length < 1) {
      //   missingFields.push("insurance missing");
      // } else {
      //   const insurance = insuranceArray[0];

      //   if (insurance) {
      //     Object.keys(insurance).forEach((key) => {
      //       if (
      //         key !== "address2" &&
      //         key !== "middleName" &&
      //         key !== "groupPolicyNumber"
      //       ) {
      //         if (!insurance[key]) {
      //           missingFields.push(
      //             `Field ${key} is missing in insurance object at index 0`
      //           );
      //         }
      //       }
      //     });
      //   } else {
      //     missingFields.push("Insurance object at index 0 is missing");
      //   }
      // }

      if (missingFields.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missingFields.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        missingFields = [];
        return;
      }

      const selectedState = values.state?.trim();
      const enteredZipCode = values.zipCode?.trim();
      const insuranceselectedState = values.insurancestate?.trim();
      const insuranceenteredZipCode = values.insurancezipCode?.trim();
      if (selectedState && enteredZipCode) {
        const stateZipCodeEntries = stateZipCodes.filter(
          (entry) => entry.ste_name === selectedState
        );

        const isZipValid = stateZipCodeEntries.some(
          (entry) => entry.zip_code === enteredZipCode
        );

        if (!isZipValid) {
          await swal({
            title: "Invalid Zip Code",
            text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
            icon: "warning",
            dangerMode: true,
          });
          return;
        }
      }

          if (insuranceselectedState && insuranceenteredZipCode) {
        const stateZipCodeEntries = stateZipCodes.filter(
          (entry) => entry.ste_name === insuranceselectedState
        );

        const isZipValid = stateZipCodeEntries.some(
          (entry) => entry.zip_code === insuranceenteredZipCode
        );

        if (!isZipValid) {
          await swal({
            title: "Invalid Zip Code",
            text: `The zip code you entered is not valid for ${insuranceselectedState}. Please enter a valid zip code.`,
            icon: "warning",
            dangerMode: true,
          });
          return;
        }
      }


let finalinsurancearray = [];

finalinsurancearray.push({
  firstName: values.insurancefirstName || "",
  middleName: values.insurancemiddleName || "",
  lastName: values.insurancelastName || "",
  address1: values.insuranceaddress1 || "",
  address2: values.insuranceaddress2 || "",
  city: values.insurancecity || "",
  state: values.insurancestate || "",
  zipCode: values.insurancezipCode || "",
  identificationNumber: values.insuranceidentificationNumber || "",
  groupPolicyNumber: values.insurancegroupPolicyNumber || "",
  dob: values.insurancedob || new Date(),
  gender: values.insurancegender || "",
  relationshipToInsured: values.insurancerelationshipToInsured || "",
  authorization: values.insuranceauthorization || "",
  authorizationEndDate: values.insuranceauthorizationEndDate || "",
  payer: values.insurancepayer || {},
});

      let payload = {
        form1: {
          ...values,
          name: `${values?.firstName} ${values?.lastName}`,
          services: servicesinfo,
          diagnosis,
        },

        form2: {
          // insurance: [insuranceData],
          // BillingInsurance: [insuranceArray[0]],
          BillingInsurance:finalinsurancearray
        },

        facilityId: facility.map((f) => f?.id),
        providerId: [selectedProvider?.id],
        payerId: payer,
      };

      // let decryptform1=encrypt(payload.form1)
      // let decryptform2=encrypt(payload.form2)

      // console.log("payload", payload);

      let obj = {
        name: `${payload?.form1?.firstName} ${payload?.form1?.lastName}`,
        form1: payload.form1,
        form2: payload.form2,
        facilityId: payload.facilityId,
        providerId: payload.providerId,
        form3: [],
      };

      console.log("obj", obj);

       let response = await addPatient(obj,true);

      // // navigate("/home/billing");

      if (response?.status === 200) {
        getAllPatientsModal();
        swal({
          title: `client addded successfully`,
          text: "client addded successfully",
          dangerMode: false,
        });

        form?.reset();
        handleClose();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const nextbtn = () => {
    setDiagnosisField({
      code: "",
      name: "",
    });
    setServices(null);

    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }

    // else {

    //   setCurrentStep(currentStep - 1);

    // }
  };

  const updatestate = (step) => {
    setCurrentStep(step);
  };

  const renderContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <>
            <form>
              <div className={classes.formRow}>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    First Name *
                  </Text>
                  <CustomTextInput
                    id="first-name"
                    size="sm"
                    // withAsterisk
                    {...form.getInputProps("firstName")}
                    onChange={(e) => {
                      form.setFieldValue('firstName', e.target.value)
                      form.setFieldValue('insurancefirstName', e.target.value)
                    }}
                  />
                </Box>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Middle Name *
                  </Text>
                  <CustomTextInput
                    id="first-name"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("middleName")}
                      onChange={(e) => {
                      form.setFieldValue('middleName', e.target.value)
                      form.setFieldValue('insurancemiddleName', e.target.value)
                    }}
                  />
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Last Name *
                  </Text>
                  <CustomTextInput
                    id="last-name"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("lastName")}
                    onChange={(e) => {
                      form.setFieldValue('lastName', e.target.value)
                      form.setFieldValue('insurancelastName', e.target.value)
                    }}
                  />
                </Box>
              </div>

              <Box mt={10}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Address 1
                </Text>
                <CustomTextInput
                  id="address1"
                  size="sm"
                  withAsterisk
                  {...form.getInputProps("previousAddress")}
                      onChange={(e) => {
                      form.setFieldValue('previousAddress', e.target.value)
                      form.setFieldValue('insuranceaddress1', e.target.value)
                    }}
                />
              </Box>

              <Box mt={10}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Address 2
                </Text>
                <CustomTextInput
                  id="address2"
                  size="sm"
                  withAsterisk
                  {...form.getInputProps("previousAddress2")}
                            onChange={(e) => {
                      form.setFieldValue('previousAddress2', e.target.value)
                      form.setFieldValue('insuranceaddress2', e.target.value)
                    }}
                />
              </Box>

              <Box style={{ marginTop: "12px" }} className={classes.mt19}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Select Facility
                </Text>
                <CustomSelectBox
                  id="billing"
                  // default={"+1"}
                  withAsterisk
                  data={(allfacilty && allfacilty?.allFacilities?.facilities
                    ? allfacilty?.allFacilities?.facilities
                    : []
                  ).map((item) => ({
                    // console.log('item chekc',item)

                    value: item,
                    label: item.name,
                  }))}
                  // disabled={selectedProvider && selectedProvider?.facilityId}
                  value={facility}
                  onChange={(value) =>
                    !facility.find((f) => f?.id === value?.id) &&
                    setFacility([...facility, value])
                  }
                />
                <Box className={classes.maintags}>
                  {facility?.map((value, index) => (
                    <Group key={index} className={classes.minitags}>
                      {/* <Badge color="#344054" radius="xs" size="lg">
                        {value?.name}
                      </Badge> */}

                      <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                        {value?.name}
                      </Text>

                      <img
                        onClick={() =>
                          setFacility(
                            facility.filter((f) => f?.id !== value?.id)
                          )
                        }
                        style={{ width: "12px", cursor: "pointer" }}
                        src={"/assets/images/x.png"}
                        alt="Icon"
                      />

                      {/* <Button
                        className={classes.close}
                        color="red"
                        variant="light"
                        onClick={() =>
                          setFacility(
                            facility.filter((f) => f?.id !== value?.id)
                          )
                        }
                      >
                        Remove
                      </Button> */}
                    </Group>
                  ))}
                </Box>
              </Box>
              <Box style={{ marginTop: "12px" }} className={classes.mt19}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Select Provider
                </Text>

                <CustomSelectBox
                  id="billing-type"
                  // default={"+1"}
                  required
                  withAsterisk
                  data={(allbillingprovider &&
                  allbillingprovider?.billingprovider
                    ? allbillingprovider?.billingprovider
                    : []
                  ).map((item) => ({
                    // console.log('item chekc',item)

                    value: item,
                    label: item.name,
                  }))}
                  value={selectedProvider}
                  onChange={(value) => setSelectedProvider(value)}
                />
              </Box>

              <div style={{ marginTop: "19px" }} className={classes.formRow}>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    State
                  </Text>
                  <CustomSelectBox
                    id="state"
                    size="sm"
                    withAsterisk
                    data={Array.from(
                      new Set(stateZipCodes?.map((obj) => obj.ste_name))
                    )
                      ?.sort()
                      ?.map((ste_name) => ({
                        value: ste_name,
                        label: ste_name,
                      }))}
                    {...form.getInputProps("state")}
                    onChange={(value) => {
                    form.setFieldValue('state', value);
                    form.setFieldValue('insurancestate', value); 
                  }}

              

                    searchable
                  />
                </Box>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    City
                  </Text>
                  <CustomTextInput
                    id="city"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("city")}
                    onChange={(e) => {
                      form.setFieldValue('city', e.target.value)
                      form.setFieldValue('insurancecity', e.target.value)
                    }}
                  />
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Zip Code
                  </Text>

                  {/* <CustomSelectBox
                    id="zip-code"
                    type="number"
                    size="sm"
                    withAsterisk
                    disabled={!form?.values?.state}
                    data={
                      form?.values?.state
                        ? stateZipCodes
                            ?.filter(
                              (obj) => obj?.ste_name === form?.values?.state
                            )
                            ?.map((obj) => ({
                              value: obj?.zip_code,
                              label: obj?.zip_code,
                            }))
                        : []
                    }
                    {...form.getInputProps("zipCode")}
                    searchable
                  /> */}

                  <CustomTextInput
                    id="zip-code"
                    type="number"
                    // label={"Facility Name"}
                    {...form.getInputProps("zipCode")}
                           onChange={(e) => {
                      form.setFieldValue('zipCode', e.target.value)
                      form.setFieldValue('insurancezipCode', e.target.value)
                    }}
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                  />
                </Box>
              </div>

              <div className={classes.formRow}>
                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Gender
                  </Text>
                  <CustomSelectBox
                    id="gender"
                    placeholder="Select"
                    withAsterisk
                    data={[
                      { value: "Male", label: "male" },
                      { value: "Female", label: "female" },
                    ]}
                    {...form.getInputProps("gender")}
                      onChange={(value) => {
                      form.setFieldValue('gender',value)
                      form.setFieldValue('insurancegender',value)
                    }}
                  />
                </Box>

                <Box className={classes.container}>
                  <Text ff="Inter" fz={14} fw={500} color="#344054">
                    Phone Number
                  </Text>

                  <Box className={classes.boxWrapper}>
                    <Select
                      className={classes.selectBilling}
                      rightSection={
                        <IconChevronDown color={"#94A3B8"} size={20} />
                      }
                      id="billing-type"
                      placeholder="Type"
                      withAsterisk
                      variant="unstyled"
                      value={"+1"}
                      readOnly
                      data={[{ value: "+1", label: "+1" }]}
                      onChange={(value) =>
                        form.setFieldValue(
                          "phone",
                          value + form?.values?.phone?.slice(2)
                        )
                      }
                    />

                    <TextInput
                      className={classes.inputField}
                      id="billing-name"
                      type="text"
                      size="sm"
                      placeholder="000-000-000"
                      withAsterisk
                      variant="unstyled"
                      onChange={(e) =>
                        form.setFieldValue(
                          "phone",
                          form.values?.phone?.substring(0, 2) + e.target.value
                        )
                      }
                      {...form.getInputProps("phone")}
                    />
                  </Box>
                </Box>

                <Box className={classes.fullw}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    DOB
                  </Text>
                  {/* <CustomTextInput id="dob" size="sm" withAsterisk /> */}

                  {/* <CustomTextInput


                    id="city"
                    size="sm"
                    withAsterisk
                    {...form.getInputProps("dob")}
                  /> */}

                  <DatePickerInput
                    id="dob"
                    // defaultDate={Date.now()}

                    className={classes.datepickerinput}
                    sx={{
                      "& .mantine-1e6hn20": {
                        border: "none",
                        minHeight: "fit-content !important",
                      },

                      "& .mantine-1d4lrir": {
                        border: "none !important",
                      },
                    }}
                    // defaultValue={new Date()}
                    // size="xl"
                    placeholder="24/01/2008"
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/billingcalendar.png"}
                        alt="Icon"
                      />
                    }
                    styles={{ rightSection: { pointerEvents: "none" } }}
                    {...form.getInputProps("dob")}
                      onChange={(value) => {
                      form.setFieldValue('dob',value)
                      form.setFieldValue('insurancedob',value)
                    }}
                  />
                </Box>
              </div>
            </form>
          </>
        );

      case 1:
        return (
          <>
            <Box className={classes.searchbox}>
              <Select
                icon={<IconSearch size={25} />}
                // style={{borderRadius:'8px',border:'1px solid #D0D5DD'}}
                sx={{
                  ".mantine-1qj7q0z": {
                    display: "none",
                  },
                }}
                placeholder="Search Service, Service Title"
                data={
                  selectedProvider && selectedProvider.services
                    ? selectedProvider.services
                        .filter((item) => {
                          return !servicesinfo.some(
                            (service) =>
                              service.servicetitle === item.servicetitle &&
                              service.servicenumber === item.servicenumber
                          );
                        })
                        .map((item) => ({
                          value: item,
                          label: item?.servicetitle,
                        }))
                    : []
                }
                onChange={(value) => {
                  handleServiceChange(value);
                }}
              />
            </Box>
            <Box className={classes.dflex}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Service Title
                </Text>

                <CustomTextInput
                  value={services?.servicetitle || ""}
                  readOnly
                  size="sm"
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Service Code
                </Text>
                <CustomTextInput
                  value={services?.servicenumber || ""}
                  onChange={(e) =>
                    handleServiceFieldChange("servicenumber", e.target.value)
                  }
                  readOnly
                  // value={serviceInfo.servicenumber}
                  // onChange={(e) => handleServiceChange("servicenumber", e.target.value)}

                  size="sm"
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Approved
                </Text>

                <CustomSelectBox
                  id="billing-type"
                  placeholder="Select"
                  readOnly
                  withAsterisk
                  data={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  value={
                    eligibilitystatus?.notallowed
                      ? "no"
                      : eligibilitystatus?.allowed
                      ? "yes"
                      : "no"
                  }
                  onChange={(value) =>
                    handleServiceFieldChange("approved", value)
                  }
                />
              </Box>
            </Box>

            <Box className={classes.gap}>
              <Box className={classes.container}>
                <Text ff="Inter" fz={14} fw={500} color="#344054">
                  Approved Unit
                </Text>

                <Box className={classes.boxWrapper}>
                  <TextInput
                    // value={services?.servicechargetype || ""}
                    className={classes.selectBilling}
                    rightSection={
                      <IconChevronDown color={"#94A3B8"} size={20} />
                    }
                    placeholder="Unit"
                    withAsterisk
                    variant="unstyled"
                    readOnly
                    size="sm"
                    value={services?.servicechargetype}
                  />

                  <TextInput
                    className={classes.inputField}
                    id="billing-name"
                    variant="unstyled"
                    type="number"
                    size="sm"
                    value={services?.servicechargeAmount || ""}
                    placeholder={"Amount"}
                    withAsterisk
                    onChange={(e) =>
                      handleServiceFieldChange(
                        "servicechargeAmount",
                        e.target.value
                      )
                    }
                  />
                </Box>
              </Box>

              <Box className={classes.fullw}>
                {/* <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer Service Cost
                </Text> */}
                <Box className={classes.lookupflex}>
                  <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                    Service Cost
                  </Text>
                  <Text
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setOpenLookup(true);
                    }}
                    ff={"Inter"}
                    fz={12}
                    fw={500}
                    color="#FD853A"
                  >
                    Lookup Rates
                  </Text>
                </Box>

                <CustomTextInput
                  // Ensure the value is a number and calculate the result
                  // value={
                  //   // Number(services?.servicechargeNumber) *
                  //   //   Number(services?.servicechargeAmount)
                  //   //
                  //   (Number(services?.servicechargeAmount) / Number(services?.servicechargetype) * Number(services?.servicechargeNumber)).toFixed(2)
                  //    ||
                  //   services?.servicechargeNumber
                  // }
                  value={services?.servicechargeNumber}
                  onChange={(e) =>
                    handleServiceFieldChange(
                      "servicechargeNumber",
                      e.target.value
                    )
                  }
                  // onChange={(e) =>
                  //   handleServiceFieldChange(
                  //     "finalamount",
                  //     value={Number(services?.servicechargeNumber) * Number(services?.servicechargeAmount)}
                  //   )
                  // }

                  // placeholder="amount"
                  size="sm"
                />
              </Box>
            </Box>

            <Box className={classes.dflex} style={{ marginTop: "16px" }}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Billing Modifier <Text component="span" fz={12} color="#98A2B3">(Optional)</Text>
                </Text>
                <CustomTextInput
                  value={services?.mod1 || ""}
                  onChange={(e) =>
                    handleServiceFieldChange("mod1", e.target.value)
                  }
                  placeholder="e.g. U1"
                  size="sm"
                />
              </Box>
            </Box>

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: "24px",
                gap: "10px",
                marginBottom: "48px",
              }}
            >
              <Button
                type="button"
                c={"#FFF"}
                onClick={addService}
                variant="fixed"
                bg={"black"}
                radius={8}
                size="sm"
                w={"100%"}
              >
                + Add Service
              </Button>

              {/* <Button
                type="button"
                c={"#FFF"}
                onClick={() => setIsEligibilityModalVisible(true)}
                variant="light"
                bg={"black"}
                size="sm"
                w={"100%"}
              >
                Eligibility Verfication
              </Button> */}
            </Box>

            {servicesinfo?.length > 0 ? (
              <>
                <Divider></Divider>

                <Box style={{ marginTop: "19px" }}>
                  <Paper
                    sx={{
                      borderRadius: "8px !important",
                      border: "1px solid #E5E5E5 !important",
                      paddingTop: "12px",
                    }}
                    withBorder
                  >
                    <Table className={classes.table} striped>
                      <thead>
                        <tr>
                          <th className={classes.tableheader}>Service Name</th>
                          <th className={classes.tableheader}>Code</th>
                          <th className={classes.tableheader}>Value Type</th>
                          <th className={classes.tableheader}>Approved Unit</th>
                          <th className={classes.tableheader}>
                            Payer Service Cost
                          </th>
                          <th className={classes.tableheader}>Modifier</th>
                          <th className={classes.tableheader}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {servicesinfo?.map((existingService, index) => (
                          <tr key={index}>
                            <td className={classes.tablepara}>
                              {existingService?.servicetitle}
                            </td>
                            <td className={classes.tablepara}>
                              {existingService?.servicenumber}
                            </td>
                            {/* <td className={classes.tablepara}>
                              {existingService?.servicechargetype || "N/A"}
                            </td> */}
                            <td className={classes.tablepara}>
                              <TextInput
                                ta={"center"}
                                className={classes.newinputbox}
                                readOnly
                                value={
                                  existingService?.servicechargetype || "N/A"
                                }
                                variant="unstyled"
                              />
                            </td>

                            {/* <td className={classes.tablepara}>
                              {existingService?.servicechargeNumber || "N/A"}
                            </td> */}

                            <td className={classes.tablepara}>
                              <TextInput
                                ta={"center"}
                                className={classes.newinputbox}
                                readOnly
                                value={
                                  existingService?.servicechargeAmount || "N/A"
                                }
                                variant="unstyled"
                              />
                            </td>

                            <td className={classes.tablepara}>
                              <TextInput
                                ta={"center"}
                                className={classes.newinputbox}
                                readOnly
                                value={existingService.servicechargeNumber}
                                variant="unstyled"
                              />
                            </td>

                            <td className={classes.tablepara}>
                              {existingService?.mod1 || "-"}
                            </td>

                            <td>
                              <Button
                                className={classes.close}
                                onClick={() => removeServices(index)}
                                color="red"
                                variant="light"
                              >
                                Remove
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Paper>
                </Box>
              </>
            ) : null}
          </>
        );

      case 2:
        return (
          <>
            {/* <Text
              style={{ marginBottom: "9px" }}
              ff={"Inter"}
              fz={14}
              fw={500}
              color="#171717"
            >
              Diagnosis
            </Text> */}

            <Box style={{ marginBottom: "24px" }}>
              <BillingSearchBar
                placeholder="Search diagnos name..."
                data={(alldiagnosiscode &&
                alldiagnosiscode.diagnosiscode &&
                diagnosisSearchValue
                  ? alldiagnosiscode.diagnosiscode
                  : []
                ).map((item) => ({
                  value: item,
                  label: item?.shortdescription,
                  key: item?.code,
                }))}
                onChange={(item) => {
                  typeof item === "string" && item && getdiagnosiscode(item);
                  setDiagnosisField({
                    code: item?.code,
                    name: item?.shortdescription,
                  });
                }}
                value={
                  typeof diagnosisSearchValue === "string"
                    ? diagnosisSearchValue
                    : diagnosisSearchValue?.shortdescription
                }
                setValue={setDiagnosisSearchValue}
              />
            </Box>
            <Box className={classes.dflex}>
              <Box className={classes.widthbox}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Diagnosis Name
                </Text>
                <CustomTextInput
                  name="code"
                  // disabled={true}
                  readOnly
                  size="sm"
                  value={diagnosisField?.name}
                />
              </Box>

              <Box className={classes.widthbox}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Diagnosis ID
                </Text>
                <CustomTextInput
                  name="code"
                  // disabled={true}
                  readOnly
                  size="sm"
                  value={diagnosisField?.code}
                />
              </Box>

              {/* <Button
              // onClick={nextbtn}
              onClick={() => handleChangeDiagnosis()}
              variant="filled"
              c={"#000"}
              mt={10}
              radius={"md"}
              size="md"
              color="yellow"
            >
              Save
            </Button> */}
            </Box>

            <Box
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "24px",
                marginBottom: "48px",
              }}
            >
              <Button
                type="button"
                c={"#FFF"}
                onClick={() => handleChangeDiagnosis()}
                variant="fixed"
                bg={"black"}
                size="sm"
                w={"100%"}
              >
                + Add
              </Button>
            </Box>

            {diagnosis.length > 0 ? (
              <>
                <Divider></Divider>

                <Box style={{ marginTop: "19px" }}>
                  <Paper
                    sx={{
                      borderRadius: "8px !important",
                      border: "1px solid #E5E5E5 !important",
                      padding: "26px 0px 14px 0px",
                    }}
                    withBorder
                  >
                    <Table className={classes.table} striped>
                      <thead>
                        <tr>
                          <th
                            className={classes.tableheader}
                            // style={{
                            //   textAlign: "center",
                            //   padding: "10px",
                            //   borderBottom: "2px solid #ddd",
                            // }}
                          >
                            Diagnosis Name
                          </th>
                          <th
                            className={classes.tableheader}
                            // style={{
                            //   textAlign: "center",
                            //   padding: "10px",
                            //   borderBottom: "2px solid #ddd",
                            // }}
                          >
                            Diagnosis ID
                          </th>
                          <th
                            className={classes.tableheader}
                            // style={{
                            //   textAlign: "center",
                            //   padding: "10px",
                            //   borderBottom: "2px solid #ddd",
                            // }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {diagnosis?.map((value, index) => (
                          <tr key={index}>
                            <td className={classes.tablepara}>
                              {value.name}
                              {/* <CustomTextInput
              name="code"
              readOnly
              size="sm"
              value={value.name}
            /> */}
                            </td>
                            <td className={classes.tablepara}>
                              {value?.code}
                              {/* <CustomTextInput
              name="code"
              readOnly
              size="sm"
              value={value?.code}
            /> */}
                            </td>
                            <td className={classes.tablepara}>
                              <Button
                                className={classes.close}
                                onClick={() => removeDiagnosis(index)}
                                color="red"
                                variant="light"
                              >
                                Remove
                                {/* <IconTrash size={24} /> */}
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Paper>
                </Box>
              </>
            ) : null}
          </>
        );

      case 3:
        return (
          <form onSubmit={form.onSubmit((values) => onSave(values))}>
            <div className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured First Name
                </Text>
                <CustomTextInput
                  id="first-name"
                  size="sm"
                  // value={insuranceData.firstName}
                  // onChange={handleInsuranceChange}
                //   onChange={(e) =>{
                //     form.setFieldValue()
                //     // handleInsuranceChange("firstName", e.target.value)
                //   }
                // }
                {...form.getInputProps("insurancefirstName")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Middle Name
                </Text>
                <CustomTextInput
                  id="middle-name"
                  size="sm"
                  // value={insuranceData.middleName}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("middleName", e.target.value)
                  // }
                  {...form.getInputProps("insurancemiddleName")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Last Name
                </Text>
                <CustomTextInput
                  id="last-name"
                  size="sm"
                  {...form.getInputProps("insurancelastName")}
                  // value={insuranceData.lastName}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("lastName", e.target.value)
                  // }
                />
              </Box>
            </div>

            <Box className={classes.mt19}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Insured Address 1
              </Text>
              <CustomTextInput
                id="address1"
                size="sm"
                // value={insuranceData.address1}
                // // onChange={handleInsuranceChange}
                // onChange={(e) =>
                //   handleInsuranceChange("address1", e.target.value)
                // }
                  {...form.getInputProps("insuranceaddress1")}
              />
            </Box>

            <Box mt={10}>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Insured Address 2
              </Text>
              <CustomTextInput
                id="address2"
                size="sm"
                // value={insuranceData.address2}
                // // onChange={handleInsuranceChange}

                // onChange={(e) =>
                //   handleInsuranceChange("address2", e.target.value)
                // }
                {...form.getInputProps("insuranceaddress2")}
              />
            </Box>

            <div style={{ marginTop: "19px" }} className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  City
                </Text>
                <CustomTextInput
                  id="city"
                  size="sm"
                  withAsterisk
                  // value={insuranceData.city}
                     {...form.getInputProps("insurancecity")}
                  // // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("city", e.target.value)
                  // }
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  State
                </Text>
                <CustomSelectBox
                  id="state"
                  size="sm"
                  withAsterisk
                  // value={insuranceData?.state}
                  data={Array.from(
                    new Set(stateZipCodes?.map((obj) => obj.ste_name))
                  ).map((ste_name) => ({
                    value: ste_name,
                    label: ste_name,
                  }))}
                  // onChange={(e) => handleInsuranceChange("state", e || "")}
                     {...form.getInputProps("insurancestate")}
                  limit={10}
                  searchable
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Zip Code
                </Text>

                {/* <CustomSelectBox
                  id="zip-code"
                  type="number"
                  size="sm"
                  withAsterisk
                  // value={insuranceData.zipCode}
                  disabled={!insuranceData?.state}
                  data={
                    insuranceData?.state
                      ? stateZipCodes
                          ?.filter(
                            (obj) => obj?.ste_name === insuranceData?.state
                          )
                          ?.map((obj) => ({
                            value: obj?.zip_code,
                            label: obj?.zip_code,
                          }))
                      : []
                  }
                  // onChange={(e) => handleInsuranceChange("zipCode", e || "")}
                       {...form.getInputProps("insurancezipCode")}
                  limit={5}
                  searchable
                /> */}


                 <CustomTextInput
                    id="zip-code"
                    type="number"
                    // label={"Facility Name"}
                    {...form.getInputProps("insurancezipCode")}
              
                    size="sm"
                    // placeholder={"Enter Medication Name"}
                    // {...form.getInputProps("medicationName")}
                    withAsterisk
                    // disabled={isPreview}
                  />

                {/* <CustomTextInput
                  size="sm"
                  id="zip-code"
                   type="text"
                  // disabled={!insuranceData?.state}
                  value={insuranceData?.zipCode}
                  // onChange={handleInsuranceChange}
                  onChange={(e) => handleInsuranceChange("zipCode", e || "")}
                /> */}
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer
                </Text>

                {/* <CustomSelectBox
                  id="billing-type"
                  // default={"+1"}
                  required
                  withAsterisk
                  limit={10}
                  searchable
                  value={insuranceData.payer?.value}
                  data={(allpayer && allpayer?.payer
                    ? allpayer?.payer
                    : []
                  ).map((item) => ({
                    value: item.id,
                    label: item?.payerName,
                  }))}

                {...form.getInputProps("insurancepayer")}
                  onChange={(value) => {
                    const selectedPayer = allpayer?.payer?.find(
                      (item) => item.id === value
                    );
                    if (selectedPayer) {
                      setInsuranceData({
                        ...insuranceData,
                        payer: {
                          value: selectedPayer.id,
                          name: selectedPayer.payerName,
                        },
                      });
                    }
                  }}
                /> */}

<CustomSelectBox
  id="billing-type"
  required
  withAsterisk
  // limit={10}
  searchable
   value={form.values.insurancepayer?.value || ""} // selected payer ID

  data={(allpayer?.payer || []).map((item) => ({
    value: item.id,
    label: item.payerName,
  }))}

  onChange={(value) => {
    const selectedPayer = allpayer?.payer?.find(
      (item) => item.id === value
    );

    if (selectedPayer) {
      const payerObject = {
        value: selectedPayer.id,
        name: selectedPayer.payerName,
      };

  form.setFieldValue("insurancepayer", payerObject);
      // form.getInputProps("insurancepayer", payerObject);
    } 
  }}
/>


              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured ID Number
                </Text>
                <CustomTextInput
                  id="dob"
                  size="sm"
                 // value={insuranceData.identificationNumber}
                  // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange(
                  //     "identificationNumber",
                  //     e.target.value
                  //   )
                  // }
                  {...form.getInputProps("insuranceidentificationNumber")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Group ID
                </Text>
                <CustomTextInput
                  id="dob"
                  size="sm"
                  //value={insuranceData.groupPolicyNumber}
                  // onChange={handleInsuranceChange}
                  // onChange={(e) =>
                  //   handleInsuranceChange("groupPolicyNumber", e.target.value)
                  // }
                      {...form.getInputProps("insurancegroupPolicyNumber")}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured DOB
                </Text>

                {/* <CustomTextInput
                  id="dob"
                  size="sm"
                  withAsterisk
                  onChange={(e) =>
                    handleInsuranceChange("dob", e?.target?.value)
                  }
                /> */}

                <DatePickerInput
                  id="dob"
                  // defaultDate={Date.now()}

                  className={classes.datepickerinput}
                  defaultValue={new Date()}
                  sx={{
                    "& .mantine-1e6hn20": {
                      border: "none",
                      minHeight: "fit-content !important",
                    },

                    "& .mantine-1d4lrir": {
                      border: "none !important",
                    },
                  }}
                  // size="xl"
                  placeholder="mm/dd/yyyy"
                  icon={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  // onChange={(e) =>
                  //   handleInsuranceChange("dob", e?.target?.value)
                  // }
                  // onChange={(value) => handleInsuranceChange("dob", value)}
                  {...form.getInputProps("insurancedob")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Authorization #
                </Text>

                <CustomTextInput
                  id="dob"
                  size="sm"
                  withAsterisk
                  // onChange={(e) =>
                  //   handleInsuranceChange("authorization", e?.target?.value)
                  // }
                  {...form.getInputProps("insuranceauthorization")}
                />
              </Box>

              <Box className={classes.fullw}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Authorization End Date
                </Text>

                {/* <CustomTextInput
                  id="dob"
                  size="sm"
                  withAsterisk
                  onChange={(e) =>
                    handleInsuranceChange("authorizationEndDate", e?.target?.value)
                  }
                /> */}

                <DatePickerInput
                  id="insuranceauthorizationEndDate"
                  // defaultDate={Date.now()}
                     defaultValue={new Date()}

                  className={classes.datepickerinput}
                  // defaultValue={new Date()}
                  // size="xl"
                  sx={{
                    "& .mantine-1e6hn20": {
                      border: "none",
                      minHeight: "fit-content !important",
                    },

                    "& .mantine-1d4lrir": {
                      border: "none !important",
                    },
                  }}
                  placeholder="mm/dd/yyyy"
                  icon={
                    <img
                      style={{ width: "20px" }}
                      src={"/assets/images/billingcalendar.png"}
                      alt="Icon"
                    />
                  }
                  styles={{ rightSection: { pointerEvents: "none" } }}
                  // onChange={(e) =>
                  //   handleInsuranceChange("dob", e?.target?.value)
                  // }
                  // onChange={(value) =>
                  //   handleInsuranceChange("authorizationEndDate", value)
                  // }
                     {...form.getInputProps("insuranceauthorizationEndDate")}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Gender
                </Text>
                <CustomSelectBox
                  id="gender"
                  placeholder="Select"
                  // value={insuranceData.gender}
                  // onChange={handleInsuranceChange}

                  data={[
                    { value: "Male", label: "male" },
                    { value: "Female", label: "female" },
                  ]}
                  // onChange={(e) => handleInsuranceChange('gender', e.target.value)}
                  // onChange={(value) => handleInsuranceChange("gender", value)}
                   {...form.getInputProps("insurancegender")}
                />
              </Box>

              <Box style={{ width: "61%" }}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Insured Relationship
                </Text>
                <CustomSelectBox
                  id="gender"
                  placeholder="Select"
                  data={[
                    { value: "18", label: "self" },
                    { value: "1", label: "spouse" },
                    { value: "19", label: "child" },
                    { value: "G8", label: "other" },
                  ]}
                  // value={insuranceData.relationshipToInsured}
                  // // onChange={handleInsuranceChange}
                  // onChange={(value) =>
                  //   handleInsuranceChange("relationshipToInsured", value)
                  // }
                  {...form.getInputProps("insurancerelationshipToInsured")}
                />
              </Box>
            </div>

            <Box className={classes.addbtn}>
              <Button
                onClick={handleClose}
                size="md"
                variant="fixed"
                radius={8}
                style={{ border: "1px solid #D0D5DD" }}
                c="#1D2939"
                bg="#F9FAFB"
              >
                Cancel
              </Button>

              <Button
                // onClick={onSave}
                type="submit"
                variant="filled"
                c="#000"
                radius={8}
                size="md"
                color="yellow"
              >
                Submit
              </Button>
            </Box>
          </form>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    //getServicecode()
    getAllPatientsModal();
    // getAllPatients(currentPage, true, selectedTab);
  }, []);

  // console.log("currentStep", currentStep);

  return (
    <>
      <Drawer
        opened={state.addClient}
        //////

        offset={8}
        radius="md"
        size="45%"
        sx={{
          ".mantine-1fholi4": {
            color: "#000",
          },
          ".mantine-1ddebd9": {
            background: "#F5F5F5",
          },
          ".mantine-1fholi4:hover": {
            color: "#FFAF4A",
          },
          ".mantine-1q36a81": {
            padding: "0",
          },
        }}
        zIndex={1000}
        // title="Add Provider"
        // sx={{
        //    backgroundColor: "red !important",
        // }}
        title={
          <span style={{ fontSize: "24px", fontWeight: "700", color: "#000" }}>
            Add Client
          </span>
        }
        className={classes.customBox}
        position="right"
        scrollAreaComponent={ScrollArea.Autosize}
        overlayProps={{ backgroundOpacity: 2.5, blur: 4 }}
        /////

        // title="Add Client"
        shadow="md"
        onClose={handleClose}
        // overlayProps={{ blur: 3 }}
        // radius={"lg"}
        // zIndex={1000}
        centered
        styles={{
          title: {
            color: "#000",
            fontWeight: "bold",
            fontSize: "24px",
          },
        }}
      >
        <Box className={classes.mainbox}>
          <Box className={classes.stepsclient}>
            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(0)}>
              <Text ff={"Inter"} fz={14} fw={500} ta="center" color="#3F3F46">
                1
              </Text>
              <Text
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 0 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                ta="center"
                fz={14}
                fw={500}
                color="#3F3F46"
              >
                Client Personal Data
                {selectedProvider && facility?.length > 0 && currentStep > 0 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>

            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(1)}>
              <Text ta="center" ff={"Inter"} fz={14} fw={500} color="#3F3F46">
                2
              </Text>
              <Text
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 1 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                fz={14}
                ta="center"
                fw={500}
                color="#3F3F46"
              >
                Client Service Details
                {servicesinfo.length > 0 && currentStep > 1 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>

            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(2)}>
              <Text ta="center" ff={"Inter"} fz={14} fw={500} color="#3F3F46">
                3
              </Text>
              <Text
                ta="center"
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 2 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                fz={14}
                fw={500}
                color="#3F3F46"
              >
                Diagnosis
                {diagnosis.length > 0 && currentStep > 2 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>

            <Box style={{ cursor: "pointer" }} onClick={() => updatestate(3)}>
              <Text ta="center" ff={"Inter"} fz={14} fw={500} color="#3F3F46">
                4
              </Text>
              <Text
                ta="center"
                style={{
                  marginTop: "12px",
                  borderBottom: currentStep === 3 ? "2px solid #000" : "none",
                }}
                ff={"Inter"}
                fz={14}
                fw={500}
                color="#3F3F46"
              >
                Client Insurance Details
                {insuranceArray.length > 0 && currentStep > 3 ? (
                  <img
                    width={30}
                    style={{ position: "relative", left: "10px" }}
                    src="/assets/images/Check icon.png"
                    alt="check-icon"
                  />
                ) : null}
              </Text>
            </Box>
          </Box>

          <Text
            style={{ marginBottom: "9px" }}
            ff={"Inter"}
            fz={14}
            fw={500}
            color="#171717"
          >
            {currentStep === 0 && "Client Personal Details"}
            {currentStep === 1 && "Client Service Details"}
            {currentStep === 2 && "Diagnosis"}
            {currentStep === 3 && "Insurance Details"}
          </Text>

          <Box className={classes.addbox}>{renderContent()}</Box>

          <Box className={classes.dbtnflex}>
            {currentStep < 3 && (
              <Button
                // classNames={classes.button}
                // onClick={() => {
                //   setCurrentStep(currentStep - 1);
                // }}
                onClick={handleClose}
                size="md"
                variant="fixed"
                radius={8}
                style={{ border: "1px solid #D0D5DD" }}
                className={classes.backNextBtn}
                c="#1D2939"
                bg="#F9FAFB"
              >
                Cancel
              </Button>
            )}

            {currentStep <= 2 && (
              <Button
                onClick={nextbtn}
                variant="filled"
                c={"#000"}
                radius={8}
                size="md"
                color="yellow"
                className={classes.backNextBtn}
              >
                Next
              </Button>
            )}
          </Box>
        </Box>
      </Drawer>

      {/* <CheckEligibilty
        state={isEligibilityModalVisible}
        setState={setIsEligibilityModalVisible}
        selectedData={{
          provider: selectedProvider?.id,
          payer: payerclient[0]?.id,
          client: {
            firstName: form?.values?.firstName || "",
            lastName: form?.values?.lastName || "",
            relationshipToInsured: insuranceData?.relationshipToInsured || "18",
          },
        }}
      /> */}

      <ProviderServicesLookupModal
        openlookup={openlookup}
        setOpenLookup={setOpenLookup}
      />
    </>
  );
}

export default AddClient;
